import SpecialtyAlbumGreetingModal, {
  SPECIALTY_ALBUM_GREETING_MODAL,
} from './modal';

export default SpecialtyAlbumGreetingModal;
export { SPECIALTY_ALBUM_GREETING_MODAL };
